import { modelComposition } from 'trait/composition'

const descriptor = 'model::equipment'

export default modelComposition(descriptor)
